//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Logout = createAsyncThunk(
  "Logout",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingLogout(""));
      const response = await UsePortalApi(
        `Patient/Logout`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
       dispatch(gettingLogoutSuccess(response)) 
      } else {
        dispatch(
          gettingLogoutFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingLogoutFailed(error));
    }
  }
);
const LogoutSlice = createSlice({
  name: "Logout",
  initialState: {
    LogoutData: null,
    isLogoutLoading: false,
    isLogoutError: false,
  },
  reducers: {
    gettingLogout: (state, action) => {
      state.LogoutData = null;
      state.isLogoutLoading = true;
      state.isLogoutError = false;
    },
    gettingLogoutSuccess: (state, action) => {
      console.log(action.payload ,"LogoutData11")
      state.LogoutData = action.payload;
      state.isLogoutLoading = false;
      state.isLogoutError = false;
    },
    gettingLogoutFailed: (state, action) => {
      state.LogoutData = null;
      state.isLogoutLoading = false;
      state.isLogoutError = true;
    },
    gettingLogoutClear: (state, action) => {
      state.LogoutData = null;
      state.isLogoutLoading = false;
      state.isLogoutError = false;
    },
  },
});
export const {
  gettingLogout,
  gettingLogoutSuccess,
  gettingLogoutFailed,
  gettingLogoutClear,
} = LogoutSlice.actions;
export default LogoutSlice.reducer;
